import {RegionModel} from './RegionModel';
import {LocalCustomerModel} from './LocalCustomerModel';
import {ResourcesUnitModel} from './ResourcesUnitModel';
import {ProviderModel} from './ProviderModel';

export class ForecastModel {

  region: RegionModel;
  localCustomer: LocalCustomerModel;
  resourceUnit: ResourcesUnitModel;
  provider: ProviderModel;


  constructor(  provider?: ProviderModel, region?: RegionModel, localCustomer?: LocalCustomerModel,
                resourceUnit?: ResourcesUnitModel) {

    this.region = region;
    this.localCustomer = localCustomer;
    this.resourceUnit = resourceUnit;
    this.provider = provider;
  }
}
